
    import './styles.scoped.css';
    export default {};
  